import * as React from "react"
import { format } from "date-fns"
import { toZonedTime } from "date-fns-tz"

import { useActiveWorkspaceTimezone } from "@/features/auth/hooks/use-active-workspace-timezone"
import { PeriodPreset, resolvePeriodRange } from "@/shared/lib/dates/period-range"

/**
 * Resolve a config period preset (carried in the URL) to `YYYY-MM-DD` from/to bounds in the workspace
 * timezone — the shape the accounting/engine endpoints expect. Returns empty bounds when no preset.
 */
export function useResolvedPeriod(preset: string | undefined): { from?: string; to?: string } {
  const timeZone = useActiveWorkspaceTimezone()
  return React.useMemo(() => {
    if (!preset) return {}
    const zonedNow = toZonedTime(new Date(), timeZone)
    const range = resolvePeriodRange(preset as PeriodPreset, { now: zonedNow, weekStartsOn: 1 })
    if (!range) return {}
    return { from: format(range.start, "yyyy-MM-dd"), to: format(range.end, "yyyy-MM-dd") }
  }, [preset, timeZone])
}
